var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('object',{staticClass:"obj-footer",attrs:{"data":("/web/Common/snippet/footer.html?json=" + (encodeURIComponent(JSON.stringify(_vm.footer))))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }